import { useSelector } from 'react-redux';
import classes from './NotificationsElement.module.scss';

export default function NotificationsElement() {
  const notifs = useSelector((state) => state.notification.notification);

  const lis = notifs.map((nt) => (
    <li className={`${classes.element}`} key={nt.text}>
      <div className={classes.detail}>
        <span className={classes.from}>FROM: {nt.from}</span>
        <span className={classes.to}>TO: {nt.to}</span>
        <span className={classes.align}>
          <span className={classes.text}>
            Text:
            <span className={classes['message']}>{nt.text}</span>
          </span>
        </span>
      </div>
      <span className={classes.date}>{nt.date}</span>
    </li>
  ));

  return <ul className={classes.list}>{lis}</ul>;
}
